import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Col, Container, Row } from 'react-bootstrap';
import classNames from 'classnames';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import { circulationResource } from '../../resource';
import '../../style/accessibleView.scss';

/**
 * Container for activation
 */
class Activation extends Component {
  state = {
    loaded: false,
    accessibleView: sessionStorage.getItem('accessibleView')
  };

  componentDidMount() {
    const { match } = this.props;
    const pathParams = match.params;

    circulationResource
      .activateRegistration(pathParams)
      .then(data => {
        this.setState({
          loaded: true,
          message: `activation.response.${data.printLine}.message`
        });
      })
      .catch(() => {
        this.setState({
          loaded: true,
          message: 'activation.error.fatal.message'
        });
      });
  }

  changeView(isChanged) {
    this.setState({
      accessibleView: !isChanged
    });
  }

  render() {
    const { loaded, message, accessibleView } = this.state;

    return (
      <>
        <div className={classNames({ accessibleActivationView: !accessibleView })}>
          <Header
            title={<FormattedMessage id="header.activation.title" />}
            changeView={this.changeView.bind(this)}
          />
          <Container id="main">
            <Row>
              <Col>
                <div className={loaded ? null : 'embedded-loading-indicator'}>
                  <div>{message ? <FormattedMessage id={message} /> : null}</div>
                  <div className="text-center mt-2">
                    <Button variant="primary" href="/">
                      <FormattedMessage id="button.backToOpac" />
                    </Button>
                  </div>
                  {loaded ? null : <LoadingIndicator />}
                </div>
              </Col>
            </Row>
          </Container>
          <Footer />
        </div>
      </>
    );
  }
}

export default injectIntl(Activation);
